import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Animated } from "react-animated-css";
import { serviceAdmin } from '../../config';

import LoginCard from './LoginCard';
import './login.css';

class Login extends Component {

	componentDidMount() {
		if (!(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
			let params = new URL(document.location.toString()).searchParams;
			if(!params.get("auth_token")){
				window.location.href = serviceAdmin + '?action=logout';
			}
		}
	}

	render() {
		return (
			<Animated animationIn="fadeIn">
				<div className="loginWrapper loginPage" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<div className="fullIcon"></div>
					<div className='service-name'>Campaign Management</div>
					<LoginCard />
					<div className="disclaimer">Craffview @ 2025 All Rights Reserved.</div>
				</div>
			</Animated>
		);
	}
}

const mapStateToProps = state => ({
	userAuthenticated: state.user.userAuthenticated
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Login);
